<div class="mat-typography mat-body mat-app-background">
    <div class="dialog-close">
      <span class="material-symbols-outlined" role="button" tabindex="0" (click)="closeModal()">close</span>
    </div>
    <article class="content-section">
      <!-- Header -->
      <h2>
        <slot name="header">NOTICE</slot>
      </h2>

      <!-- Description -->
      <section class="description">
      @if (data.showAPTCWarning) {
        <p>
          Please note: you are eligible to apply an Advanced Premium Tax Credit (APTC) to your monthly premium. If you would like to apply your Advanced Premium Tax Credit (APTC) to your premium, please close this window and make a new selection.
        </p>
      }
      @if (data.showCSRWarning) {
        <p>
          Please note: You are only eligible for Cost-Sharing Reduction (CSR) if you choose a Silver-level plan.  If you would like to select a Silver-level plan, close this window and make a new selection.
        </p>
      }
      </section>

      <section class="buttons">
        <button mat-raised-button color="primary" type="button" (click)="continueToEnrollment()"><span>
            <slot name="confirm">CONTINUE TO ENROLLMENT</slot>
          </span></button>
        <button mat-raised-button color="primary" type="button" (click)="closeModal()"><span>
            <slot name="abort">RETURN TO PLAN SELECTION</slot>
          </span></button>
      </section>
    </article>
  </div>